<div class="modal-header">
    <h6 class="modal-title pull-left"> {{updateId==''?'Add':'Edit' }} User</h6>
    <button type="button" class="close btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-md-6 col-sm-12">
            <div class="form-group">
                <label for="ID">User Name</label>
                <input type="text" id="orgname" placeholder="Enter User Name" class="form-control"
                    [(ngModel)]="addUserObj.user_name">
            </div>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="form-group">
                <label for="ID">Event</label>
                <ng-select class="selectpicker selecterchart" [(ngModel)]="addUserObj.org_ref_id"
                    (ngModelChange)="onOrgChange($event)">
                    <ng-option value="" disabled="true">Select Event</ng-option>
                    <ng-option *ngFor="let org of orgList; let i = index" [value]="org.id">{{ org.org_name }}
                    </ng-option>
                </ng-select>
                <div *ngIf="this.remaining>0 " class="invalid-feedback">
                    Remaining {{this.remaining>1?"users":'user'}} {{this.remaining}}
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="form-group">
                <label for="ID">Is Allowed</label><br>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="1"
                        [(ngModel)]="addUserObj.value" (change)="onItemChange($event.target.value)">
                    <label class="form-check-label" for="inlineRadio1">Yes</label>

                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="0"
                        [(ngModel)]="addUserObj.value" (change)="onItemChange($event.target.value)">
                    <label class="form-check-label" for="inlineRadio2">No</label>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger btn-sm" (click)="activeModal.dismiss()">Cancel</button>&nbsp;
    <button type="button" class="btn btn-primary btn-sm" (click)="save()">Save</button>
</div>